@if (column && column.filter) {
  @switch (column.type) {
    @case ('date') {
      @if (column.filterType === 'daterange') {
        <app-input-daterange-picker
          size="small"
          data-cy="datePicker"
          [dateRange]="value"
          (dateRangeChange)="filterChange($event, column)"
          [placeholder]="column.display ?? column.field"
          [isDisabled]="isLoading"
          appendTo="body"
        />
      } @else {
        <chitin-form-input
          type="date"
          size="small"
          [isDisabled]="isLoading"
          [placeholder]="column.display ?? column.field"
          [value]="value"
          (valueChange)="filterChange($event, column)"
          format="MM/dd/yyyy"
        />
      }
    }
    @case ('datetime') {
      @if (column.filterType === 'daterange') {
        <app-input-daterange-picker
          size="small"
          [dateRange]="value"
          (dateRangeChange)="dateRangeValueChange($event, column)"
          [placeholder]="column.display ?? column.field"
          [isDisabled]="isLoading"
          appendTo="body"
        />
      } @else {
        <chitin-form-input
          type="date"
          size="small"
          [isDisabled]="isLoading"
          [placeholder]="column.display ?? column.field"
          [value]="value"
          (valueChange)="filterChange($event, column)"
          format="MM/dd/yyyy"
        />
      }
    }
    @case ('multi-select') {
      <chitin-select-old
        [isDisabled]="isLoading"
        [items]="column.filterOptions ?? []"
        [itemsStream]="column.filterOptionsStream"
        [placeholder]="column.display ?? column.field"
        [clearable]="true"
        [searchable]="true"
        [displayNumberOfSelected]="true"
        [multiple]="true"
        valueType="value"
        [value]="value"
        (valueChange)="filterChange($event, column)"
        displayExpr="name"
        valueExpr="value"
        size="sm"
      />
    }
    @case ('select') {
      <chitin-select-old
        [isDisabled]="isLoading"
        [items]="column.filterOptions ?? []"
        [itemsStream]="column.filterOptionsStream"
        [placeholder]="column.display ?? column.field"
        [clearable]="true"
        [searchable]="true"
        valueType="value"
        [value]="value"
        (valueChange)="filterChange($event, column)"
        displayExpr="name"
        valueExpr="value"
        size="sm"
      />
    }
    @default {
      <chitin-form-input
        [isDisabled]="isLoading"
        [emissionDelayInMs]="1500"
        [placeholder]="column.display ?? column.field"
        [value]="value"
        (valueChange)="filterChange($event, column)"
        size="small"
      />
    }
  }
}
